import { OrderById } from '@models';

export const DISTRICT_PLACEHOLDER = 'Sin distrito';

/**
 * District shown for a registro: the shipping district when there is a
 * shipping detail, otherwise the order's own district, otherwise the
 * placeholder. Shared by the desktop card, the mobile sheet and the detail
 * page so the three views cannot drift apart.
 */
export function getOrderDistrict(
  order: Pick<OrderById, 'shippingDetail' | 'district'>,
  placeholder: string = DISTRICT_PLACEHOLDER,
): string {
  return order.shippingDetail?.district ?? order.district ?? placeholder;
}
